module.exports = __webpack_public_path__ + "static/media/sq_rpx.064dc763.png";